import { faAngleDown, faAngleUp } from '@fortawesome/pro-regular-svg-icons'
import { Box, Flex, Text } from '@mantine/core'
import {
  ChannelBox,
  type ChannelItem as IChannelItem,
} from '@nessprim/planby-pro'

import { useTranslation } from '@flecto/translations'
import { type CoreItem } from '@flecto/types'
import { AvatarItem, Icon, TextItemCategory } from '@flecto/ui'
import { useItemQuantityInfo } from '@flecto/utils'

export const ChannelItem = (props: IChannelItem) => {
  const { t } = useTranslation('saas', { keyPrefix: 'schedule' })
  const { channel, isVerticalMode, onOpenGroupTree } = props
  const { groupTree, isNestedChild, isOpen, itemCategory, position, item } =
    channel

  const { quantityLabel } = useItemQuantityInfo({ item })

  return (
    <ChannelBox
      groupTree={groupTree}
      isVerticalMode={isVerticalMode}
      onClick={() => onOpenGroupTree?.(channel)}
      {...position}
      className='planby-channel'
      style={{
        background: isNestedChild ? 'white' : 'var(--mantine-color-gray-0)',
        borderBottom: isNestedChild
          ? '1px solid var(--mantine-color-gray-1)'
          : '1px solid transparent',
        marginTop: -1,
      }}
    >
      <Flex align='center' gap='sm' w='100%'>
        <Box style={{ overflow: 'hidden' }}>
          {groupTree ? (
            <TextItemCategory
              c='dimmed'
              fw={500}
              categoryId={itemCategory.id}
              size='sm'
              withBreadcrumbNames
            />
          ) : (
            <Flex align='center' gap='sm'>
              <AvatarItem item={(item as CoreItem) ?? {}} size='md' />
              <Box>
                <Text fw={500} size='sm' truncate='end'>
                  {item.title}
                </Text>
                <Text c='dimmed' size='xs' truncate='end'>
                  {t('total_quantity')}: {quantityLabel}
                </Text>
              </Box>
            </Flex>
          )}
        </Box>
      </Flex>
      {groupTree && (
        <Icon
          color='dimmed'
          icon={isOpen ? faAngleUp : faAngleDown}
          size='xs'
        />
      )}
    </ChannelBox>
  )
}
